import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  formatLabel,
  fetchOptionIds,
  formatId,
  displayError,
  numberFormatProps,
  formatBackSpaces,
} from '../../../utils';
import { Answer } from '../../../models';

import { Input } from 'antd';

import { formActions } from '../../../actions';
import { connect } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { useCallback } from 'react';

const Text = ({
  id,
  label,
  question_number,
  help,
  answer,
  saveAnswer,
  required,
  options,
  fields,
  readonly,
  special,
  financialYear,
}) => {
  const [error] = useState(false);
  const inputRef = useRef(null);
  const textAreaRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(null);

  const handleChange = useCallback(
    e => {
      var val = e.target.value;
      // Sorry about this, this is horrendous but fixes the fact that we don't have controlled inputs
      // Store cursor position before updating
      setCursorPosition(e.target.selectionStart);
      // VALIDATION error state
      saveAnswer(Answer(fetchOptionIds(options)[0], val));
    },
    [options, saveAnswer]
  );

  // Sorry about this, this is horrendous but fixes the fact that we don't have controlled inputs
  // Restore cursor position after value changes
  useEffect(() => {
    if (!cursorPosition) {
      return;
    }

    const input =
      inputRef.current || textAreaRef.current?.resizableTextArea?.textArea;

    if (input) {
      input.setSelectionRange(cursorPosition, cursorPosition);
      setCursorPosition(null);
    }
  }, [answer.value, cursorPosition]);

  const formattedId = useMemo(() => formatId(id), [id]);
  const value = useMemo(() => answer.value || '', [answer.value]);

  if (readonly) {
    return (
      <p>
        {formatLabel(label, null, null, null, question_number, financialYear)}
        <span>{formatBackSpaces(answer.value || '')}</span>
      </p>
    );
  }

  const { TextArea } = Input;

  return (
    <p>
      {formatLabel(label, id, required, help, question_number, financialYear)}
      {special !== 'textarea' ? (
        special !== 'number' ? (
          <Input
            ref={inputRef}
            type={!special ? 'text' : special}
            id={formattedId}
            name={formattedId}
            onChange={e => handleChange(e)}
            pattern={fields[0].validation !== '' ? fields[0].validation : null}
            title={fields[0].validation_help}
            placeholder={fields[0].title}
            value={value}
          />
        ) : (
          <NumericFormat
            id={formattedId}
            name={formattedId}
            onChange={(e, value) => handleChange(e, value)}
            placeholder={fields[0].title}
            value={value}
            {...numberFormatProps()}
          />
        )
      ) : (
        <Fragment>
          <TextArea
            ref={textAreaRef}
            id={formattedId}
            name={formattedId}
            onChange={e => handleChange(e)}
            pattern={fields[0].validation !== '' ? fields[0].validation : null}
            title={fields[0].validation_help}
            maxLength={fields[0].length}
            placeholder={fields[0].title}
            autoSize={{ minRows: 3, maxRows: 20 }}
            value={value}
          />
          {fields[0]?.length > 0 && (
            <small className="char-count">
              Caractères restants :{' '}
              {fields[0].length - (answer.value || '').length} /
              {fields[0].length}
            </small>
          )}
        </Fragment>
      )}

      {error && <small className="error">{displayError()}</small>}
    </p>
  );
};

Text.propTypes = {
  id: PropTypes.number,
  label: PropTypes.string,
  question_number: PropTypes.string,
  help: PropTypes.string,
  answer: PropTypes.object,
  saveAnswer: PropTypes.func,
  required: PropTypes.bool,
  options: PropTypes.array,
  fields: PropTypes.array,
  readonly: PropTypes.bool,
  special: PropTypes.string,
  multiple: PropTypes.bool,
  financialYear: PropTypes.number,
};

const mapStateToProps = (state, props) => {
  var optionId = (fetchOptionIds(props.options) || [])[0];

  return {
    financialYear: state.form.base.financialYear,
    answer: state.form.answers[optionId] || {},
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveAnswer: answer => dispatch(formActions.saveAnswer(answer)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Text);
